
import React from "react";

import {
  Box,
  Breadcrumbs,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import QrPay from "components/QrPay";
import { useToast } from "utils/useToast";

// Настройки услуг ЕРИП
const SERVICES = {
  subscription: {
    name: "Абонентская плата ТВ",
    srv: "5123",
  },

  adv: {
    name: "Реклама, объявления",
    srv: "187263",
  },
};

// Общая часть пути ЕРИП
const ERIP_PATH = [
  "Интернет, телевидение, телефония",
  "Прочие организации",
  "Витебская обл.",
  "Чашникский р-н",
  "ТриАнда",
];

export default function EripPayment({
  service = "subscription",
  summ = "",
}) {
  const toast = useToast();

  const currentService = SERVICES[service];

  if (!currentService) {
    return null;
  }

  const eripPath = [
    ...ERIP_PATH,
    currentService.name,
  ];

  const amount =
    summ !== null && summ !== undefined
      ? String(summ).trim()
      : "";

  const copyText = async (value, message) => {
    try {
      await navigator.clipboard.writeText(value);

      toast.success(message, 1000);
    } catch (error) {
      console.error("Clipboard error:", error);
    }
  };

  const CopyButton = ({ value, message }) => (
    <Tooltip title="Копировать">
      <IconButton
        size="small"
        onClick={() => copyText(value, message)}
        sx={{ ml: 0.5 }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      {/* Путь в системе ЕРИП */}
      <Box
        sx={{
          p: {
            xs: 1.5,
            sm: 2,
          },
          mb: 3,
          borderRadius: 2,
          bgcolor: "action.hover",
        }}
      >
        <Typography
          sx={{
            mb: 1.5,
            fontWeight: 600,
          }}
        >
          Путь в системе ЕРИП
        </Typography>

        <Breadcrumbs
          separator={
            <NavigateNextIcon
              fontSize="small"
              color="action"
            />
          }
          sx={{
            "& .MuiBreadcrumbs-ol": {
              alignItems: "center",
            },
            "& .MuiBreadcrumbs-li": {
              mb: 0.5,
            },
          }}
        >
          {eripPath.map((item) => (
            <Chip
              key={item}
              label={item}
              size="small"
              variant="outlined"
            />
          ))}
        </Breadcrumbs>
      </Box>

      {/* QR-код и информация об оплате */}
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={2}
          alignItems="center"
        >
          <QrPay
            srv={currentService.srv}
            size={160}
          />

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              textAlign: {
                xs: "center",
                sm: "left",
              },
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                mb: 0.5,
              }}
            >
              Оплата через ЕРИП
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 1.5 }}
            >
              Отсканируйте QR-код камерой телефона
              или нажмите на него.
              <br />
              На следующей странице выберите
              приложение своего мобильного банка.
            </Typography>

            {/* Код услуги */}
            <Stack
              direction="row"
              spacing={0.5}
              alignItems="center"
              justifyContent={{
                xs: "center",
                sm: "flex-start",
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
              >
                Код услуги:
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 1,
                }}
              >
                {currentService.srv}
              </Typography>

              <CopyButton
                value={currentService.srv}
                message="Код услуги скопирован в буфер"
              />
            </Stack>

            {/* Сумма к оплате */}
            {amount !== "" && (
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                justifyContent={{
                  xs: "center",
                  sm: "flex-start",
                }}
                sx={{ mt: 0.5 }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  Сумма к оплате:
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    letterSpacing: 1,
                  }}
                >
                  {amount}
                </Typography>

                <CopyButton
                  value={amount}
                  message="Сумма скопирована в буфер"
                />
              </Stack>
            )}
          </Box>
        </Stack>
      </Box>
    </>
  );
}
